// Module
var code = `<div class="modal fade" id="addNewCustomerModal" tabindex="-1" role="dialog" data-bind="showModal: show">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" data-bind="click: clear">
          <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title" data-bind="label: 'cc_P_ADDRESS_BOOK_RECORD'"></h4>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <metrix-text
                params="labelCols:'5', fieldCols:'7', label: 'cc_P_CUSTOMER_NAME', value: addressBookRecord().cf1, isRequired: true"
              ></metrix-text>
            </div>
          </div>
          <div class="col-md-12">
            <br ></br>
            <div class="form-group">
              <label
                class="label-control col-md-5 requiredMark editable-pre-wrapped"
                data-bind="label: 'cc_P_CUSTOMER_ADDRESS'"
              ></label>
              <div class="col-md-7">
                <textarea
                  class="form-control"
                  data-bind="value: addressBookRecord().cf2 ,placeholder:'cc_P_CUSTOMER_ADDRESS'"
                  rows="3"
                  style="resize: none"
                ></textarea>
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <div class="form-group">
              <metrix-text
                params="labelCols:'5', fieldCols:'7', label: 'cc_P_CUSTOMER_ZIP', value: addressBookRecord().cf3, isRequired: true"
              ></metrix-text>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <metrix-text
                params="labelCols:'5', fieldCols:'7', label: 'cc_P_CUSTOMER_DISTANCE', value: addressBookRecord().cf4, isRequired: true"
              ></metrix-text>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-bind="label:'Save', click: save"></button>
        <button
          type="button"
          class="btn btn-default"
          data-dismiss="modal"
          data-bind="click: clear, label: 'cc_Close'"
        ></button>
      </div>
    </div>
  </div>
</div>
`;
// Exports
module.exports = code;